import $ from 'jquery';
import LP from '../0-lp';

LP.dlgSaveImage = {
  open: function (title, image, width, height) {
    var url = 'backend/saveImageDialog/';
    width = Math.max(width + 100, 350);
    height = Math.max(height + 220, 250);
    LP.Dialog.open({
      name: 'saveimage',
      width: width,
      height: height,
      ajax: url,
      title: title,
      sizeable: false,
      /*onResize:LP.dlgSaveImage.onResize,*/
      onLoad: function () {
        LP.dlgSaveImage.onLoad(image);
      },
    });
  },

  onLoad: function (image) {
    var div = $(document.createElement('div')).addClass('lp-saveimage-container');
    $('.lp-saveimage-div').append(div);
    $('.lp-saveimage-container').append(image);
  },

  onResize: function () {},
};
